import { render, staticRenderFns } from "./PolicyList.vue?vue&type=template&id=08b576a6&scoped=true"
import script from "./PolicyList.vue?vue&type=script&lang=js"
export * from "./PolicyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b576a6",
  null
  
)

export default component.exports